<script>

export default {
    name: "VariationCard",
    props: {
        /*-- tvpackage.dto.VariationCardDto" */
        dto: {
            type: Object,
            required: true,
        },
    },
}
</script>

<template>
    <div
        class="container mw-100 ob1-card px-1 me-1"
        :class="(dto.detainedVariation || dto.notEligibleVariation) ? '' : 'ob1-card-multiple'"
    >
        <div class="col-12 px-0">
            <div class="row">
                <div v-if="dto.detainedVariation" class="col-12">
                    <div class="corner-banner">
                        <span class="icon icon-tick text-white corner-banner-icon float-end" />
                    </div>
                </div>

                <!--/* BANNIERE */-->
                <div class="col-12 px-1">
                    <div class="row align-items-center internet-banner">
                        <div v-if="dto.tag" class="col-auto p-0 pe-1">
                            <div class="ob1-tag ob1-tag-primary">
                                <span v-text="dto.tag" />
                            </div>
                        </div>
                    </div>
                </div>

                <!--/* TITRE DE LA VARIATION */-->
                <div class="col-12 py-1 px-2">
                    <div class="bloc-title">
                        <div class="h3 mb-0 pb-0" v-text="dto.label" />
                    </div>
                </div>

                <!--/* SEPARATION */-->
                <div class="col-12 px-2 text-center separator-before-price">
                    <hr class="separator separator--gray4">
                </div>

                <!--/* PRICE */-->
                <div v-if="dto.price" class="col-12 px-2 pt-1">
                    <div class="bloc-price">
                        <ob1-prix
                            class="price-align"
                            :custom="priceCustomClasses"
                            :duration="dto.price.duration"
                            :initial-price="dto.price.initialPrice"
                            :is-compact="dto.price.compact"
                            :price="dto.price.price"
                            :price-label="dto.price.priceLabel"
                            :price-details="dto.price.priceDetails"
                            :show-by-month="dto.price.showByMonth"
                            :show-end-of-promotion-price="dto.price.showEndOfPromotionPrice"
                            :show-from="dto.price.showFrom"
                            :show-promo-duration="dto.price.showPromoDuration"
                            :additional-mention-normal="dto.price.additionalMention"
                        />
                        <div>
                            <div class="bloc-price-mentions">
                                <span
                                    v-if="dto.legalNotice"
                                    v-safe-html="dto.legalNotice"
                                    class="ob1-price ob1-price-compact ob1-price-promo-duration"
                                >Mention légale</span>
                                <br v-if="dto.legalNotice && dto.commitment">
                                <span
                                    v-if="dto.commitment"
                                    v-safe-html="dto.commitment"
                                    class="ob1-price-promo-duration text-black fw-bold"
                                >Engagement X mois</span>
                                <br v-if="dto.commitment && dto.terminationDetailLink">
                                <br v-if="!dto.commitment && dto.legalNotice && dto.terminationDetailLink">
                                <div v-if="dto.terminationDetailLink">
                                    <a
                                        v-safe-html="dto.terminationDetailLink.linkLabel"
                                        data-bs-toggle="modal"
                                        href="#"
                                        class="ob1-link"
                                        :data-bs-target="'#modal-termination-' + dto.terminationDetailLink.popinName"
                                        :data-oevent-category="dto.terminationDetailLink.tmsData.category"
                                        :data-oevent-action="dto.terminationDetailLink.tmsData.action"
                                        :data-oevent-label="dto.terminationDetailLink.tmsData.label"
                                    >Résiliable à tout moment</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div
                    v-if="dto.detainedVariation"
                    class="col-12 px-2 py-1 d-flex justify-content-center"
                >
                    <div class="bloc-button w-100">
                        <p role="alert" class="alert alert-info">
                            <span aria-hidden="true" class="alert-icon"></span>
                            <span
                                class="ob1-alert-title"
                                :data-variation-info="dto.cta.label + ' ' + dto.label"
                                v-text="dto.cta.label"
                            />
                        </p>
                    </div>
                </div>

                <!--/* SELECTION */-->
                <div v-if="!dto.detainedVariation" class="col-12 px-2 py-1 d-flex justify-content-center">
                    <div class="bloc-button w-100">
                        <a
                            class="btn btn-primary w-100"
                            :href="dto.cta.actionUrl"
                            :data-variation-cta="dto.cta.label + ' ' + dto.label"
                            :data-oevent-category="dto.cta.tmsData.category"
                            :data-oevent-action="dto.cta.tmsData.action"
                            :data-oevent-label="dto.cta.tmsData.label"
                            :class="(dto.notEligibleVariation || dto.isAuthenticatedWithoutAnyContract) ? 'disabled' : ''"
                            :aria-disabled="(dto.notEligibleVariation || dto.isAuthenticatedWithoutAnyContract)"
                        >{{ dto.cta.label }}</a>
                    </div>
                </div>

                <!--/* COMMENT S'ABONNER */-->
                <div v-if="dto.contractsLinkLabel" class="col-12 px-2 pb-1">
                    <a
                        :href="dto.contractsLinkUrl"
                        class="ob1-link"
                    >{{ dto.cta.label }}</a>
                </div>

                <!--/* SEPARATION */-->
                <div v-if="dto.attributes" class="col-12 px-2 text-center">
                    <hr class="separator separator--gray4">
                </div>

                <!--/* ATTRIBUTS */-->
                <div v-if="dto.attributes" class="col-12 pt-1 pb-2">
                    <ul class="bloc-attributs list-unstyled px-1 mb-0 ">
                        <li v-for="attribute in dto.attributes" class="attribute">
                            <div class="d-flex align-items-baseline">
                                <span
                                    v-if="attribute.icon"
                                    class="icon"
                                    :class="attribute.icon"
                                    aria-hidden="true"
                                />
                                <span v-safe-html="attribute.description" class="attribute-label ps-1">2 écrans</span>
                            </div>
                        </li>
                    </ul>
                </div>

            </div>
        </div>
    </div>
</template>

<style scoped lang="scss">

</style>
